/**
 * Created by jv on 2019-10-14 (11:41).
 */
require("slick-carousel/slick/slick.scss");
require("slick-carousel/slick/slick-theme.scss");

const log = require("Sources/utils/logger")();
import utils from "Sources/utils/utils";
import LanguageManager from "Sources/services/language-manager";
import "slick-carousel/slick/slick";

const CloseSvgIcon = require("!raw-loader!Images/icons/btn_plus.svg");
const ArrowShortSvg = require("!raw-loader!Images/icons/btn_arrow_short.svg");

require("Styles/components/business-model-dialog.scss");
require("Styles/components/slider-dialog.scss");
require("Styles/components/example-case-dialog.scss");

class ExampleCaseDialog {
  constructor(options) {
    this.dialogId = utils.generateElementId("example-case-dialog-");

    this.investment = options.investment;
    this.investments = options.investments;

    this.callbackContext = options.callbackContext;
    this.onCancel = options.onCancel;
  }

  get isOpen() {
    return utils.isNotNull(this.$dialog) && this.$dialog.length && this.$dialog.hasClass("show");
  }

  create() {
    if (this._initialized !== true) {
      this.renderDialog();

      this.$dialog.appendTo("body");
      this.initialize();
    }
  }

  initialize() {
    if (this._initialized !== true) {
      this.$dialog.modal({
        backdrop: false,
        show: false
      });

      this.setUpDialogEventListeners();

      this._initialized = true;
    }
  }

  renderDialog() {
    this.$dialog = $("<div id='" + this.dialogId + "' class='modal fade' tabindex='-1' role='dialog' aria-hidden='true'>" +
      "<div class='modal-dialog modal-dialog-centered business-model-dialog slider-dialog example-case-dialog'>" +
      "<div class='modal-content'>" +
      "</div>" +
      "</div>" +
      "</div>");

    this.renderDialogContent();
  }

  renderDialogContent() {
    if (utils.isNull(this.investment)) return;

    let $dialogContent = this.$dialog.find(".modal-content");

    if (utils.isNotNull($dialogContent) && $dialogContent.length) {
      $dialogContent.empty();

      log.debug("Setting up example cases dialog card for investment - %o", this.investment);

      let $closeBtn = $("<button class='btn dialog-close-btn' type='button'></button>");
      $closeBtn.html(CloseSvgIcon);
      $dialogContent.append($closeBtn);

      let $exampleCase = $("<div class='example-case'></div>");

      // Dialog top
      let $exampleCaseTop = $("<div class='example-case__top'></div>");

      let investmentTitle = LanguageManager.getValueForKey(`serious_game.business_model.investments.back.titles.${this.investment.type}`);
      $exampleCaseTop.append(`<h5 class='example-case__dialog-title'>${investmentTitle}</h5>`);

      let $sliderPrevBtn = $(`<button class="btn btn-slider btn-slider__prev slider-dialog__prev-btn" type="button">${ArrowShortSvg}</button>`);
      let $sliderNextBtn = $(`<button class="btn btn-slider btn-slider__next slider-dialog__next-btn" type="button">${ArrowShortSvg}</button>`);
      let $imageSlider = $("<div class='example-case__image-slider'></div>");

      $exampleCaseTop.append($sliderPrevBtn);
      $exampleCaseTop.append($imageSlider);
      $exampleCaseTop.append($sliderNextBtn);

      // Dialog bottom
      let $exampleCaseBottom = $("<div class='example-case__bottom'></div>");

      let $contentSlider = $("<div class='example-case__content-slider'></div>");
      $exampleCaseBottom.append($contentSlider);

      for (let i = 0; i < this.investment.examples.length; i++) {
        let example = this.investment.examples[i];

        let $exampleImage = $("<div class='example-case__image'></div>");
        let credits = LanguageManager.getValueForKey("serious_game.business_model.investments.examples.credit.prefix") + example.credits;
        $exampleImage.append(`<figure><img src="${example.image}" alt="${example.title}"/><figcaption>${credits}</figcaption></figure>`);
        $imageSlider.append($exampleImage);

        let $exampleContent = $("<div class='example-case__content'></div>");
        $exampleContent.append(`<h6 class="example-case__content-title">${example.title}</h6>`);
        $exampleContent.append(`<p class="example-case__content-text">${example.description}</p>`);
        $contentSlider.append($exampleContent);
      }

      $exampleCase.append($exampleCaseTop).append($exampleCaseBottom);
      $dialogContent.append($exampleCase);

      this.setUpSlick();

      this.setUpEventListeners();
    }
  }

  setUpSlick() {
    let $imageSlider = this.$dialog.find(".example-case__image-slider");
    let $contentSlider = this.$dialog.find(".example-case__content-slider");

    let slickOptionsDefault = {
      focusOnSelect: false,

      mobileFirst: true,

      draggable: false,
      swipe: true,

      infinite: false,

      // dots: true,
      arrows: true,
      prevArrow: this.$dialog.find(".slider-dialog__prev-btn"),
      nextArrow: this.$dialog.find(".slider-dialog__next-btn"),

      slidesToShow: 1,
      slidesToScroll: 1,

      // Without this, adding slides after the initialize is fcked up for some reason:
      // https://github.com/kenwheeler/slick/commit/be0d17cc858fb30e6a4d6b28cc29860c7170040d#comments
      rows: 0
    };

    let imageSliderOptions = {
      ...slickOptionsDefault,
      asNavFor: $contentSlider
    };

    let contentSliderOptions = {
      ...slickOptionsDefault,
      arrows: false,
      dots: true,
      appendDots: this.$dialog.find(".modal-content"),
      asNavFor: $imageSlider
    };

    $imageSlider.slick(imageSliderOptions);
    $contentSlider.slick(contentSliderOptions);
  }

  show() {
    this.renderDialogContent();
    this.$dialog.modal("show");

    let $imageSlider = this.$dialog.find(".example-case__image-slider");
    let $contentSlider = this.$dialog.find(".example-case__content-slider");
    $imageSlider.slick("resize");
    $imageSlider.slick("setPosition");
    $contentSlider.slick("resize");
    $contentSlider.slick("setPosition");
  }

  hide() {
    this.$dialog.modal("hide");
  }

  setUpDialogEventListeners() {

  }

  setUpEventListeners() {
    this.$dialog.find(".btn").on("transitionend", (e) => {
      // transitionend fix for dialog close animations
      e.preventDefault();
      e.stopPropagation();
      return false;
    });

    this.$dialog.find(".dialog-close-btn").on("click", (e) => {
      if (utils.isFunction(this.onCancel)) {
        this.onCancel.call(this.callbackContext, this);
      }
    });
  }
}

export default ExampleCaseDialog;



// WEBPACK FOOTER //
// ./app/js/components/game/components/example-case-dialog.js